export const localPersist = "localPersist";

export const localSelectedTheme = "localSelectedTheme";

export const sortPostBy = {
  DATE: "DATE",
  TITLE: "TITLE",
};

export const postMode = {
  EDIT: "EDIT",
  CREATE: "CREATE",
};

export const MAX_SELECTED_POST=100
export const Max_IMG_Size= 2000000;
export const Global_Use_Query_Retry = 2;
export const Post_Title_Max_Char_Limit =60;